<template>
  <div class="picture_report_form" :style="screenHeight">
    <div class="fixed_search" style="height: 50px">
      <div class="date_selected fixed_search_input">
        <el-date-picker
          :clearable="false"
          v-model="starEndTime"
          unlink-panels
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          :default-time="['00:00:00','23:59:59']"
          :editable="editable"
          :picker-options="pickerOptions"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="fixed_search_input">
        <Select v-model="rwId" placeholder="请选择AI流程" clearable title="AI流程">
          <Option v-for="(option,index) in aiFlow" :key="index" :value="option.id">{{option.rwName}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="callType" placeholder="请选择呼叫类型" clearable title="呼叫类型">
          <Option v-for="(option,index) in callTypes" :key="index" :value="option.id">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <el-tooltip slot="label" effect="light" placement="top">
          <div slot="content">
            AI分类标签的统计<br>
            统计数据是统计该AI流程下所触发的标签
          </div>
          <img class="transfer-tip" :src="questionMark"/>
        </el-tooltip>
      </div>
    </div>
    <Tabs v-model="pictureIndex" :style="pictureHeight">
      <TabPane label="饼状图" name="pancake">
        <div id="pancakeTotalAITag" class="customer_total" style="width: 85%;height: 85%"></div>
      </TabPane>
      <TabPane label="柱状图" name="columnar">
        <div id="columnarTotalAITag" class="customer_total" style="width: 85%;height: 85%"></div>
      </TabPane>
    </Tabs>
    <div class="fixed_table" style="margin-top: 35px;border:1px solid #DCDFE6">
      <div class="table_head" style="border-top: 0px">
        <table>
          <tr>
            <!--<th class="font_style_set" style="width: 40%;">AI流程</th>-->
            <th class="font_style_set" style="width: 50%;">分类标签</th>
            <th class="font_style_set" style="width: 50%;">通话数量</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" :style="tableHeight">
        <table class="table_head_footer">
          <tr v-for="(item,index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <!--<td style="width: 40%;">{{item.rwName}}</td>-->
            <td style="width: 50%;">{{item.tagName}}</td>
            <td style="width: 50%;">{{item.num}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'

export default {
  name: 'AITagReport',
  mixins:[publicFunClass],
  props:{
    pageCode:String,
  },
  data(){
    return {
      showPageCount:0,
      editable:false,
      infoTableList:[],
      screenHeight:{
        height:''
      },
      tableHeight:{
        height:''
      },
      pictureHeight:{
        height:''
      },
      journalType:'null',
      menuId:'null',
      formType:'2',
      starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(), '23:59:59')],
      pictureIndex:'pancake',
      rwName:'',
      rwId:'',
      aiFlow:[],
      callType:'',
      callTypes:[{'id':'1','name':'呼入'},{'id':'3','name':'自动呼出'}],
      columnarXData:[],
      columnar1:[],
      lineXData:[],
      pancakeTotal:[],
      questionMark:require('../../../assets/image/homeAsk.png'),
    }
  },
  methods:{
    initSearch() {
      let that = this
      this.$emit("closeVn",true);
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        formType: this.formType,
        date:this.starEndTime.length === 0 ? '':this.starEndTime.toString(),
        rwId:this.rwId,
        callType:this.callType,
        journalType: this.journalType,
        menuId:this.menuId
      }
      that.columnarXData = [];
      that.columnar1 = [];
      that.pancakeTotal = []
      this.$http.post('/AI/Report/tagReport',param).then(res=>{
        let response = res.data
        if (response.flag !== '666') {
          that.$Modal.info({
            title:'提示',
            content:response.msg
          });
          return false
        }
        that.infoTableList = response.obj.data
        let columnList = response.obj.columns
        let contentList = response.obj.data
        if (contentList.length > 0) {
          for (let i = 0; i < contentList.length; i++) {
            let content = contentList[i]
            that.columnar1.push(content.num)
            that.columnarXData.push(content.tagName)
            let json = {
              value: parseInt(content.num?content.num:'0'),
              name: content.tagName
            }
            that.pancakeTotal.push(json)
          }
        }
        that.initPancakeTotal()
        that.initColumnarTotal()

      })
    },
    reset() {
      this.starEndTime = [this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')]
      this.formType = '2'
      this.rwName = ''
      this.rwId = ''
      this.callType = ''
    },
    initPancakeTotal() {
      let that = this
      let itemData = []
      let colorData = []
      for (let i = 0; i < that.pancakeTotal.length; i++) {
        let item = that.pancakeTotal[i]
        itemData.push(item.name)
        if (i < 15) {
          colorData.push(that.colors[i])
        } else {
          colorData.push(that.colors[i-15])
        }
      }
      let pancakeTotal = this.$echarts.init(document.getElementById('pancakeTotalAITag'))
      pancakeTotal.setOption({
        tooltip:{
          trigger:'item',
          formatter:'{a}<br/>{b}: {c}通 ({d}%)'
        },
        legend :{
          orient:'vertical',
          left:2,
          data:itemData,
          textStyle: {
            fontSize: 14
          }
        },
        color: colorData,
        series: [{
          name:'AI客户标签',
          type:'pie',
          radius:['60%','90%'],
          avoidLabelOverlap:false,
          label:{
            show:false,
            position:'left',
            normal:{
              show:false,
              color:'#515a6e',
              fontSize: '16',
              formatter: function(value){
                let name = value.name
                let num = value.value
                name = name.length>5?name.substring(0,5)+'...':name
                return name+'\n'+num+'通'
              },
              position:'center'
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '18',
              fontWeight: 'bold',
            }
          },
          labelLine:{
            show:true
          },
          data: that.pancakeTotal
        }]
      })
    },
    initColumnarTotal() {
      let that = this
      let columnarTotal = this.$echarts.init(document.getElementById('columnarTotalAITag'))
      columnarTotal.setOption({
        tooltip:{
          formatter:'{a}<br/>{b}: {c}通'
        },
        legend:{
          data:['AI客户标签'],
        },
        xAxis: {
          data: that.columnarXData,
          axisLabel: {
            interval: 0,
            rotate:45,
            formatter:function(value){
              return value.length > 5 ? value.substring(0,5)+'...':value
            }
          }
        },
        yAxis: [{
          minInterval:1,
          type:'value'
        }],
        series: [{
          name: 'AI客户标签',
          type: 'bar',
          barMaxWidth: 25,
          data: that.columnar1,
          color: '#79c6d8'
        }
        ]
      })
    },
  },
  created() {
    this.screenHeight.height = this.mountHeight(92)
    this.pictureHeight.height = this.mountHeight(172)
    this.tableHeight.height = this.mountHeight(250)
  },
  destroyed() {
    this.$emit('closeVn',true)
  },
  watch:{
    pageCode:{
      deep:true,
      handler(value) {
        if (value === '8_6-4' && this.showPageCount === 0) {
          this.showPageCount++
          this.getAIWorkFlow()
          this.$emit('openVn', true)
        }
      }
    }
  }
}
</script>

<style lang="css">
  .transfer-tip{
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    float: right;
    margin-top: 5px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/AIReportForm/AITagReport.vue